module.exports = __webpack_public_path__ + "static/media/gym-1.84152d40.jpg";